import React, {useEffect, useRef, useState} from 'react';
import {withTranslation} from "react-i18next";
import axios from "axios";
import {toast} from "react-toastify";
import AccordionListPopUp from '../popup/AccordionListPopUp';
import ConfirmationPopUp from '../popup/ConfirmationPopUp';
import {URL_GET_REMINDER_DETAILS, URL_GET_REMINDER_EVENT, URL_SET_REMINDER_DETAILS, URL_SET_REMINDER_EVENT} from "../../utils/urlConstants";

const STATE = {VIEW: 'VIEW', EDIT: 'EDIT'}; //enum for state

const ReminderURLComponent = (props) => {
  const [reminderDetails, setReminderDetails] = useState({
    cpAppId: props.selectedAppId,
    url: null,
    statusCode: null, //current status string
    useYN: "N", //receive reminder checkbox - N means "not stop sending reminder notification"
  });

  let reminderStatus = "INACTIVE";

  if (reminderDetails.statusCode === "APPROVED") {
    reminderStatus = "ACTIVE";
  } else {
    reminderStatus = reminderDetails.statusCode === null ? "INACTIVE" : reminderDetails.statusCode;
  }

  const urlInputRef = useRef();
  const checkboxInputRef = useRef();
  const [componentState, setComponentState] = useState(STATE.VIEW);
  const [modalState, setModalState] = useState(false);
  const [confirmSaveReminderModalState, setConfirmSaveReminderModalState] = useState(false);
  const [isOpenReminderEventListPopUp, setOpenReminderEventListPopUp] = useState(false);
  const [selectedReminderEvents, setSelectedReminderEvents] = useState([]);
  const [isButtonSelectWebhookDisabled, setIsButtonSelectWebhookDisabled] = useState(false);
  const reminderEventList = [
    {
      header: "General",
      items: [
        {key: "PURCHASED", value: "Payment Success"},
        {key: "REFUNDED", value: "Refund"},
      ]
    },
    {
      header: "Subscription",
      items: [
        {key: "SUBS_STARTED", value: "Subscription Started"},
        {key: "SUBS_CANCELED", value: "Subscription Canceled"},
        {key: "SUBS_EXPIRED", value: "Subscription Expired"},
        {key: "SUBS_RENEWED", value: "Subscription Renewed"},
        {key: "SUBS_GRACE_STARTED", value: "Grace Period Initiated"},
        {key: "SUBS_GRACE_RECOVERED", value: "Recovered within Grace Period"},
        {key: "SUBS_PLAN_CHANGE_REQUESTED", value: "Subscription Plan Changed Requested"},
        {key: "SUBS_PLAN_CHANGED", value: "Subscription Plan Changed Completed"},
        {key: "SUBS_PLAN_CHANGE_CANCELED", value: "Subscription Canceled and Reverted back to Original SKU"}
      ]
    }
  ];


  useEffect(() => {
    setReminderDetails({
      ...reminderDetails,
      cpAppId: props.selectedAppId,
    });
    getReminderDetaislFromUrl();
    getSelectedReminderEvents();
    setComponentState(STATE.VIEW);
  }, [props.selectedAppId]);

  const getSelectedReminderEvents = () => {
    axios.get(URL_GET_REMINDER_EVENT, {
      params: {
        cpAppId: props.selectedAppId
      }
    })
        .then(response => {
          setSelectedReminderEvents(response.data);
        })
        .catch(e => {
          toast("Request Failed");
        });
  }

  function getReminderDetaislFromUrl() {
    const getReminderDetails = async () => {
      //TODO: Get axios instance from some command interface (where timeout is also added in get/post + error message for post request)
      try {
        return await axios.get(URL_GET_REMINDER_DETAILS, {
          params: {
            cpAppId: props.selectedAppId
          }
        });
      } catch (e) {
        console.log("Issue happening during GET operations ", URL_GET_REMINDER_DETAILS);
        console.error(e);
        return "Failed to get data";
      }
    }

    /* option1: block the useEffect + then set data */
    /* option2: do not block the useEffect + set data  <= we are doing this below as do not use await below*/
    getReminderDetails()
        .then(response => response.data)
        .then(data => {
          setReminderDetails({
            ...reminderDetails,
            // cpAppId: data?.cpAppId || null, //Its set by app dropdown => do not include it.
            url: data?.url || null,
            statusCode: data?.statusCode || null,
            useYN: data?.useYN // returns Y N
          });

          urlInputRef.current.value = data?.url || null;
          checkboxInputRef.current.checked = data.useYN !== "Y";
          setIsButtonSelectWebhookDisabled(checkboxInputRef.current.checked);

        })
        .catch(e => {
          console.log("error message: ", e);
        });
  }

  const handleSaveOperation = () => {
    //Step1: Validate Entry
    //Step2: Issue update request to backend
    //Step3: Show success/failure message

    const isHttpValid = (str) => {
      try {
        const newUrl = new URL(str);
        // return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
        console.log("url by URL(): ", newUrl);
        return newUrl.protocol === 'https:';
      } catch (err) {
        console.error("Cannot make valid url from input");
        return false;
      }
    }

    const isUrlValid = isHttpValid(urlInputRef.current.value);
    if (isUrlValid === false) {
      toast("Input URL is not valid. Please Check");
      return;
    }
    setModalState(true);
  }

  const handleModalSaveConfirmation = () => {

    const nurl = new URL(urlInputRef.current.value);
    const ncheckboxvalue = checkboxInputRef.current.checked;
    setIsButtonSelectWebhookDisabled(checkboxInputRef.current.checked);

    axios.post(URL_SET_REMINDER_DETAILS, {
      cpAppId: reminderDetails.cpAppId,
      url: nurl,
      useYN: ncheckboxvalue ? "N" : "Y", //use Y N
    })
        .then(response => {
          console.log("success response: ", response);

          getReminderDetaislFromUrl();
          toast("Request Successful");
        })
        .catch(e => {
          console.log("error: ", e);
          toast("Request Failed");
        });

    setModalState(false);
    setComponentState(STATE.VIEW);
  }

  const handleSaveReminderEvent = selectedItems => {
    setModalState(false);
    if (selectedItems.length < 1) {
      toast("Please select at least one Reminder Event");
    } else {
      setSelectedReminderEvents(selectedItems);
      setOpenReminderEventListPopUp(false);
      setConfirmSaveReminderModalState(true);
    }
  }

  const confirmSaveReminderEvent = () => {
    setConfirmSaveReminderModalState(false);
    axios.post(URL_SET_REMINDER_EVENT, {
      cpAppId: reminderDetails.cpAppId,
      reminderEvents: selectedReminderEvents,
    })
        .then(response => {
          toast("Reminder Event updated Successfully");
        })
        .catch(e => {
          toast("Request Failed");
        });
  }

  return (
      <>
        <div className="clearfix mb-20 mt-60">
          <h2 className="mb-0"><strong>{"Reminder URL Setting"}</strong></h2>
          <p>
            Please register an URL for getting reminder notification (e.g purchases, subscription, cancellation, etc.).
            Please wait for 1-2 working days for the URL to be allowed to take effect.
          </p>
        </div>

        <div className="form-group-wrap">
          <div className="form-group row">
            <label className="col col-form-label">URL</label>
            <div className="col">
              <div className="input-group">
                <input type="url"
                       className="form-control"
                       aria-describedby="emailHelp"
                       placeholder="Enter Reminder URL "
                       ref={urlInputRef}
                       disabled={componentState === STATE.VIEW}
                       defaultValue={reminderDetails.url || ''}
                />
                <div className="input-group-append">
                  <button className="btn btn-primary"
                          type="button"
                          onClick={() => setComponentState(STATE.EDIT)}
                          hidden={componentState === STATE.EDIT}>
                    Edit
                  </button>
                </div>
              </div>
              <label className={`col-form-label`}>
                Status: {reminderStatus}
              </label>
              <div className="form-group-row" hidden={false}>
                <input
                    className="btn-checkbox"
                    type="checkbox"
                    ref={checkboxInputRef}
                    defaultChecked={reminderDetails.useYN !== "Y"}
                    disabled={componentState === STATE.VIEW}/>
                <label className="ml-6 mr-10">
                  Stop Sending Reminder Notification
                </label>
              </div>
              <div>
                <button
                    onClick={handleSaveOperation}
                    hidden={componentState === STATE.VIEW}
                    className="btn btn-primary mr-2" type="button">
                  Save
                </button>
                <button
                    onClick={() => {
                      checkboxInputRef.current.checked = reminderDetails.useYN !== "Y";
                      urlInputRef.current.value = reminderDetails.url;
                      setComponentState(STATE.VIEW);
                    }}
                    hidden={componentState === STATE.VIEW}
                    className="btn btn-primary" type="button">
                  Cancel
                </button>
              </div>
            </div>
            <label className="col col-form-label">Reminder Event &nbsp;
              <span
                  className={"tooltips"}
                  data-toggle="tooltip"
                  data-placement="top"
                  title={"Partner can select on which event(s) they'd like to receive Reminder (Webhook) notifications on"}>
                <a className="tooltip-toggle">?</a>
              </span>
            </label>

            <div className="col">
              <button
                  disabled={isButtonSelectWebhookDisabled}
                  onClick={() => setOpenReminderEventListPopUp(true)}
                  className="btn btn-primary mr-2 mt-2" type="button">
                Select
              </button>
            </div>
          </div>
        </div>

        <ConfirmationPopUp
            open={modalState}
            title={"Confirmation"}
            message={"Do You Want to Change?"}
            confirmAction={handleModalSaveConfirmation}
            cancelAction={() => setModalState(false)}
        />

        <ConfirmationPopUp
            open={confirmSaveReminderModalState}
            title={"Confirmation"}
            message={"Would you like to receive notification for the selected Reminder Events?"}
            confirmAction={confirmSaveReminderEvent}
            cancelAction={() => setConfirmSaveReminderModalState(false)}
        />

        <AccordionListPopUp
            data={reminderEventList}
            open={isOpenReminderEventListPopUp}
            title={"Reminder Event"}
            readOnly={false}
            selectableHeader={true}
            isMultipleSelect={true}
            selectedData={selectedReminderEvents} //array of keys
            disabledData={[]} //array of keys
            handleModalClose={() => setOpenReminderEventListPopUp(false)}
            handleSave={handleSaveReminderEvent}
        />
      </>);
}
export default withTranslation()(ReminderURLComponent);
